export default "/images/Coatings.webp?9d245f8de4389a76f64b8d5f8015c1cd";